import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { user } = useAuth();

    if (user === null) {
        return (
            <div
                className="min-h-screen flex items-center justify-center bg-[#f7f7f5]"
                data-testid="loading-screen"
            >
                <div className="flex items-center gap-3 text-[#0C4650]">
                    <div className="w-3 h-3 rounded-full bg-[#C7FF2C] animate-pulse" />
                    <span className="font-semibold">Caricamento…</span>
                </div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
};
